import React, { Component } from 'react';
import Files from 'react-files'
import { Creatable } from 'react-select';
import MyCreatable from '../../../component/select/Creatable';
import 'react-select/dist/react-select.css';
import { fileUpload, addNewTenant, tenantDetail } from '../../../api';
import { connect } from 'react-redux';
import { setSubBtnFontColor, setUnSubBtnFontColor, setHeadlineColor, setSubBtnBgColor, setUnsubBtnBgColor, setDefault } from '../../../redux/reducer/page';
import { getTenantList } from '../../../redux/reducer/tenant';
import ColorPicker from '../../../container/colorPicker';
import defaultLogo from '../../../assets/img/img-product.png';

@connect(
  state=>state.page,
  { setSubBtnFontColor, setUnSubBtnFontColor, setHeadlineColor, setSubBtnBgColor, setUnsubBtnBgColor, setDefault, getTenantList }
)
export default class TenantDetail extends Component{
  constructor(props) {
    super(props);
    this.state = {
      initValue: {},
      id: '',
      edit: false,
      LogoUpLoading: false,
      miniLogoUpLoading: false,

      logo: '',
      miniLogo: '',
      companyName: '',
      domain: '',
      name: '',
      mailFrom: '',
      mailSenderName: '',
      brandName: '',
      mailgunApiKey: '',
      mailgunHost: '',
      questionEmail: '',
      fontFamily: '',
      fontFamilyOption: [],
      adminName: '',
      adminPassword: '',
      repeatPassword: '',
      regional: [],
      regionalOption: [],
    };
  }
  componentDidMount() {
    $("#activity, #project-context").hide();
    if (this.props.match.params.id) {
      tenantDetail({id: this.props.match.params.id})
        .then(res=>{
          let data = res.data || {};
          if (data.headlineColor) this.props.setHeadlineColor(data.headlineColor);
          this.props.setSubBtnFontColor(data.subBtnFontColor);
          this.props.setUnSubBtnFontColor(data.unSubBtnFontColor);
          this.props.setSubBtnBgColor(data.subBtnBgColor);
          this.props.setUnsubBtnBgColor(data.unSubBtnBgColor);
          this.setState({
            initValue: data,
            id: data.id,
            edit: false,
            logo: data.logo,
            miniLogo: data.miniLogo,
            companyName: data.companyName,
            domain: data.name,
            name: data.name,
            mailFrom: data.mailFrom,
            mailSenderName: data.mailSenderName,
            brandName: data.brandName,
            mailgunApiKey: data.mailgunApiKey,
            mailgunHost: data.mailgunHost,
            questionEmail: data.questionEmail,
            fontFamily: data.fontFamily,
            regional: data.regularLoginEmailFilter,
            adminName: data.adminName,
            adminPassword: data.adminPassword,
            repeatPassword: data.adminPassword
          });
          if (data.fontFamily && data.fontFamily.length > 0) {
            let temp = [];
            data.fontFamily.split(",").forEach(v=>temp.push({value: v, label: v}));
            this.setState({fontFamilyOption: temp});
          }
          if (data.regularLoginEmailFilter && data.regularLoginEmailFilter.length > 0) {
            let temp = [];
            data.regularLoginEmailFilter.forEach(v=>temp.push({value: v, label: v}));
            this.setState({regionalOption: temp});
          }
        })
        .catch(err=>console.log(err));
    } else {
      this.props.setDefault();
      this.setState({edit: true});
    }
    let handlerSubmit = this.handlerSubmit;
    let requiredInfo = !this.props.match.params.id;
    $("#newTenantForm").validate({
      rules: {
        companyName: {required: true},
        domain: {required: true},
        mailFrom: {required: true, email: true},
        mailSenderName: {required: true},
        brandName: {required: true},
        mailgunApiKey: {required: true},
        mailgunHost: {required: true},
        questionEmail: {required: true, email: true},
        fontFamily: {required: false},
        adminName: {required: true, email: true},
        adminPassword: {required: requiredInfo, minlength: 6, maxlength: 20},
        repeatPassword: {required: requiredInfo, minlength: 6, maxlength: 20, equalTo: "#adminPassword"}
      },
      messages: {
        repeatPassword: {
          equalTo:'Please enter the same password'
        }
      },
      submitHandler: function(){
        handlerSubmit();
      },
      errorPlacement: function (error, element) {
        if (element.attr('name') === 'domain') {
          error.insertAfter(element.parent());
        } else {
          error.insertAfter(element);
        }
      }
    });
  }
  handleChange = fontFamilyOption => {
    this.setState({ fontFamilyOption });
    if (fontFamilyOption.length > 0) {
      let fontFamily = [];
      fontFamilyOption.forEach(v => {
        fontFamily.push(v.value.trim());
      });
      this.setState({fontFamily: fontFamily.join(',')});
    } else {
      this.setState({fontFamily: ''});
    }
  };
  handleChangeRe = regionalOption => {
    this.setState({ regionalOption });
    if (regionalOption.length > 0) {
      let regional = [];
      regionalOption.forEach(v => {
        regional.push(v.value.trim());
      });
      this.setState({regional: regional});
    } else {
      this.setState({regional: []});
    }
  };
  handlerSubmit = ()=>{
    let { logo, miniLogo, companyName, domain, mailFrom, mailSenderName, brandName, mailgunApiKey, mailgunHost, questionEmail, fontFamily, regional, adminName, adminPassword } = this.state;
    let {subBtnFontColor, unSubBtnFontColor, headlineColor, subBtnBgColor, unSubBtnBgColor} = this.props;
    if (!miniLogo || !logo) {
      $.bigBox({
        title : "Alert",
        content : "Please choose a logo and a banner!",
        color : "#C46A69",
        icon : "fa fa-warning shake animated",
        timeout : 6000
      });
      return;
    }
    $("#submit").button('loading');
    let body = {
      logo: logo,
      miniLogo: miniLogo,
      companyName: companyName,
      domain: `${domain}-${location.hostname}`,
      mailFrom: mailFrom,
      mailSenderName: mailSenderName,
      brandName: brandName,
      mailgunApiKey: mailgunApiKey,
      mailgunHost: mailgunHost,
      questionEmail: questionEmail,
      fontFamily: fontFamily,
      regularLoginEmailFilter: regional,
      subBtnFontColor: subBtnFontColor,
      unSubBtnFontColor: unSubBtnFontColor,
      headlineColor: headlineColor,
      subBtnBgColor: subBtnBgColor,
      unSubBtnBgColor: unSubBtnBgColor,
      adminName: adminName,
      adminPassword: adminPassword,
      name: domain
    };
    if (this.state.id) body.id = this.state.id;
    addNewTenant(body)
      .then(res => {
        if (!this.state.id) {
          this.props.history.push(`/admin/tenant/detail/${res.data.id}`);
          $("html").scrollTop(0);
          location.reload();
        } else {
          $("#submit").button('reset');
          this.setState({
            initValue: res.data,
            edit: false
          });
          let body = {
            currentPage: 1,
            pageSize: 100
          };
          this.props.getTenantList(body);
          $.bigBox({
            title : "Alert",
            content : "Update successfully!",
            color : "#739E73",
            timeout: 6000,
            icon : "fa fa-check",
            number : "Thank you"
          });
        }
      })
      .catch(err=>{
        console.log(err);
        $("#submit").button('reset');
      });
  };

  onFilesChange = (files, name) => {
    $("#submit").button('loading');
    let param = new FormData();
    param.append("file", files[0]);
    this.setState({
      [`${name}LogoUpLoading`]: true
    });
    fileUpload(param,
      {headers: {'Content-Type': 'multipart/form-data'}})
      .then(res=>{
        $("#submit").button('reset');
        this.setState({
          [`${name?"miniLogo":"logo"}`]: res.data,
          [`${name}LogoUpLoading`]: false
        });
        if (name) {
          $('.files-dropzone-miniLogo').css({
            "background-image": `url(${res.data})`
          });
        } else {
          $('.files-dropzone-logo>img').attr("src", res.data);
        }
      })
      .catch(err=>{
        this.setState({
          [`${name}LogoUpLoading`]: false
        });
        $("#submit").button('reset');
        console.log(err);
      });
  };

  onFilesError = (error, file) => {
    console.log('error code ' + error.code + ': ' + error.message);
  };

  toggleEdit = e => {
    e.preventDefault();
    if(!this.props.match.params.id) {
      this.props.history.push('/admin/tenant');
    } else {
      $("em.invalid").remove();
      this.setDefaultValue();
      this.setState({
        edit: !this.state.edit
      }, function () {
        if (this.state.logo) {
          $('.files-dropzone-logo>img').attr("src", this.state.initValue.logo);
        }
        if (this.state.miniLogo) {
          $('.files-dropzone-miniLogo').css({
            "background-image": `url(${this.state.initValue.miniLogo})`
          });
        }
      });
    }
  };

  setDefaultValue = () => {
    let { initValue } = this.state;
    if (initValue.headlineColor) this.props.setHeadlineColor(initValue.headlineColor);
    this.props.setSubBtnFontColor(initValue.subBtnFontColor);
    this.props.setUnSubBtnFontColor(initValue.unSubBtnFontColor);
    this.props.setSubBtnBgColor(initValue.subBtnBgColor);
    this.props.setUnsubBtnBgColor(initValue.unSubBtnBgColor);
    this.setState({
      logo: initValue.logo,
      miniLogo: initValue.miniLogo,
      companyName: initValue.companyName,
      domain: initValue.name,
      name: initValue.name,
      mailFrom: initValue.mailFrom,
      mailSenderName: initValue.mailSenderName,
      brandName: initValue.brandName,
      mailgunApiKey: initValue.mailgunApiKey,
      mailgunHost: initValue.mailgunHost,
      questionEmail: initValue.questionEmail,
      fontFamily: initValue.fontFamily,
      regional: initValue.regularLoginEmailFilter,
      adminName: initValue.adminName,
      adminPassword: initValue.adminPassword,
      repeatPassword: initValue.adminPassword
    });
    if (initValue.fontFamily && initValue.fontFamily.length > 0) {
      let temp = [];
      initValue.fontFamily.split(",").forEach(v=>temp.push({value: v, label: v}));
      this.setState({fontFamilyOption: temp});
    } else {
      this.setState({fontFamilyOption: []});
    }
    if (initValue.regularLoginEmailFilter && initValue.regularLoginEmailFilter.length > 0) {
      let temp = [];
      initValue.regularLoginEmailFilter.forEach(v=>temp.push({value: v, label: v}));
      this.setState({regionalOption: temp});
    } else {
      this.setState({regionalOption: []});
    }
  };
  renderRegionalText = () => {
    let {initValue} = this.state;
    if (initValue.regularLoginEmailFilter && initValue.regularLoginEmailFilter.length>0) {
      return (
        <div className="row" style={{maxWidth: 660, paddingTop: 7}}>
          {
            initValue.regularLoginEmailFilter.map((v, i)=>{
              return (
                <div className="col-xs-6" key={i} style={{wordBreak: 'break-all'}}>{v}</div>
              );
            })
          }
        </div>
      );
    } else {
      return [];
    }
  };

  render() {
    let { initValue, edit, logo, miniLogo, companyName, name, mailFrom, mailSenderName, brandName, mailgunApiKey, mailgunHost, questionEmail, fontFamilyOption, regionalOption, adminName, LogoUpLoading, miniLogoUpLoading } = this.state;
    let id = this.props.match.params.id;
    let logoUrl = logo || defaultLogo;
    let minilogoUrl = miniLogo || defaultLogo;
    return (
      <div>
        <div id="ribbon">
            {/*<span className="ribbon-button-alignment">*/}
              {/*<span id="refresh"*/}
                    {/*className="btn btn-ribbon"*/}
                    {/*data-action="resetWidgets"*/}
                    {/*data-title="refresh"*/}
                    {/*rel="tooltip"*/}
                    {/*data-placement="bottom"*/}
                    {/*data-original-title="<i className='text-warning fa fa-warning'></i> Warning! This will reset all your widget settings."*/}
                    {/*data-html="true">*/}
                {/*<i className="fa fa-refresh" />*/}
              {/*</span>*/}
            {/*</span>*/}
          <ol className="breadcrumb">
            {/*<li>Tenants &nbsp;/&nbsp; {id ? "Detail" : "Add New Tenant"}</li>*/}
            <li>Tenants</li>
            <li>{id ? "Detail" : "Add New Tenant"}</li>
          </ol>
        </div>
        <div id="content">
          <div className="row">
            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-4">
              <h1 className="page-title txt-color-blueDark">
                <i className="fa fa-table fa-fw " />
                {id ? initValue.companyName : "New Tenant"}
              </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
              <form className="form-horizontal tenantForm"
                    id="newTenantForm"
                    style={{marginTop: 12}}>
                <div className="view">
                  <h2>Basic Information</h2>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Tenant Name:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="companyName"
                                 value={companyName}
                                 className="form-control"
                                 onChange={v=>this.setState({companyName: v.target.value})}
                                 placeholder="Tenant Name" />
                          : <p>{initValue.companyName}</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Domain:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <p style={{paddingTop: 0, fontSize: 16}}>
                            <input type="text"
                                   name="domain"
                                   value={name}
                                   className="form-control"
                                   style={{maxWidth: 130, display: 'inline-block'}}
                                   onChange={v=>{
                                     this.setState({
                                       domain: v.target.value.replace(/[^a-zA-Z0-9]*/g, "").toLowerCase(),
                                       name: v.target.value.replace(/[^a-zA-Z0-9]*/g, "").toLowerCase()
                                     });
                                   }}
                                   placeholder="Domain" />
                            {`-${location.hostname}`}
                          </p>
                          : <p>{`${initValue.name?initValue.name:""}-${location.hostname}`}</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Logo:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <div style={{display: 'inline-block', verticalAlign: 'middle'}}>
                            <Files
                              className='files-dropzone-miniLogo'
                              onChange={files => this.onFilesChange(files, 'mini')}
                              onError={this.onFilesError}
                              accepts={['image/png', 'image/jpg', 'image/jpeg']}
                              multiple={false}
                              maxFileSize={10000000}
                              minFileSize={0}
                              clickable
                            >
                            </Files>
                          </div>
                          : <img src={minilogoUrl}
                                 style={{
                                   width: 40,
                                   height: 40
                                 }} />
                      }
                      {
                        edit &&
                        <small style={{
                          marginLeft: 20,
                          display: 'inline-block',
                          verticalAlign: 'middle'
                        }}>
                          <em>Upload Image (40 x 40)</em>
                        </small>
                      }
                      {
                        edit && miniLogoUpLoading &&
                        <div className="progress progress-striped active"
                             style={{
                               height: 7,
                               borderRadius: 3,
                               margin: '5px 0 0 10px',
                               width: 200,
                               display: 'inline-block'
                             }}>
                          <div className="progress-bar progress-bar-info"
                               style={{ width: '100%'}}/>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div className="view">
                  <h2>Mail Setting</h2>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Mail From:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="mailFrom"
                                 value={mailFrom}
                                 className="form-control"
                                 onChange={v=>this.setState({mailFrom: v.target.value})}
                                 placeholder="Mail From" />
                          : <p>{initValue.mailFrom}</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Mail Sender Name:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="mailSenderName"
                                 value={mailSenderName}
                                 className="form-control"
                                 onChange={v=>this.setState({mailSenderName: v.target.value})}
                                 placeholder="Mail Sender Name" />
                          : <p>{initValue.mailSenderName}</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Brand Name:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="brandName"
                                 value={brandName}
                                 className="form-control"
                                 onChange={v=>this.setState({brandName: v.target.value})}
                                 placeholder="Brand Name" />
                          : <p>{initValue.brandName}</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Key:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="mailgunApiKey"
                                 value={mailgunApiKey}
                                 className="form-control"
                                 onChange={v=>this.setState({mailgunApiKey: v.target.value})}
                                 placeholder="Mailgun API Key" />
                          : <p>*******</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Host:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="mailgunHost"
                                 value={mailgunHost}
                                 className="form-control"
                                 onChange={v=>this.setState({mailgunHost: v.target.value})}
                                 placeholder="Mailgun Host" />
                          : <p>*******</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Support Email:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="questionEmail"
                                 value={questionEmail}
                                 className="form-control"
                                 onChange={v=>this.setState({questionEmail: v.target.value})}
                                 placeholder="Support Email" />
                          : <p>{initValue.questionEmail}</p>
                      }
                    </div>
                  </div>
                </div>
                <div className="view">
                  <h2>Client Portal Setting</h2>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Banner:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <Files
                            className='files-dropzone-logo'
                            onChange={files => this.onFilesChange(files, '')}
                            onError={this.onFilesError}
                            accepts={['image/png', 'image/jpg', 'image/jpeg']}
                            multiple={false}
                            maxFileSize={10000000}
                            minFileSize={0}
                            clickable
                          >
                            <img src={logoUrl}
                                 style={{
                                   maxWidth: '100%',
                                   maxHeight: 120
                                 }} />
                          </Files>
                          : <img src={logoUrl}
                                 style={{
                                   maxWidth: 500,
                                   maxHeight: 120
                                 }} />
                      }
                      {
                        edit &&
                        <small style={{
                          marginTop: 10,
                          display: 'block'
                        }}>
                          <em>Upload Image (1000 x 120)</em>
                        </small>
                      }
                      {
                        edit && LogoUpLoading &&
                        <div className="progress progress-striped active"
                             style={{
                               height: 7,
                               borderRadius: 3,
                               margin: '5px 0 0',
                               width: 200
                             }}>
                          <div className="progress-bar progress-bar-info"
                               style={{ width: '100%'}}/>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Font Family:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <Creatable
                            name="fontFamily"
                            className="font-select"
                            value={fontFamilyOption}
                            onChange={this.handleChange}
                            multi
                            placeholder="Font Family"
                            options={[
                              { value: 'Arial', label: 'Arial' },
                              { value: 'Arial Black', label: 'Arial Black' },
                              { value: 'Arial Narrow', label: 'Arial Narrow' },
                              { value: 'Verdana', label: 'Verdana' },
                              { value: 'Georgia', label: 'Georgia' },
                              { value: 'monospace', label: 'monospace' },
                              { value: 'Tahoma', label: 'Tahoma' },
                              { value: 'Helvetica', label: 'Helvetica' },
                              { value: 'serif', label: 'serif' },
                              { value: 'sans-serif', label: 'sans-serif' }
                            ]}
                          />
                          : <p>{initValue.fontFamily}</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Subscribe Button:</label>
                    <div className="col-sm-10">
                      <ColorPicker edit={edit} kind="btn" unitType="subBtnBgColor" text="Save Preferences" />
                      <ColorPicker edit={edit} unitType="subBtnFontColor" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Unsubscribe Button:</label>
                    <div className="col-sm-10">
                      <ColorPicker edit={edit} kind="btn" unitType="unSubBtnBgColor" text="Unsubscribe" />
                      <ColorPicker edit={edit} unitType="unSubBtnFontColor" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Headline Color:</label>
                    <div className="col-sm-10">
                      <ColorPicker edit={edit} unitType="headlineColor" />
                    </div>
                  </div>
                </div>
                <div className="view">
                  <h2>Tenant Administrator</h2>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Email:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="text"
                                 name="adminName"
                                 value={adminName}
                                 className="form-control"
                                 onChange={v=>this.setState({adminName: v.target.value})}
                                 placeholder="Email" />
                          : <p>{initValue.adminName}</p>
                      }
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-2 control-label">Password:</label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <input type="password"
                                 id="adminPassword"
                                 name="adminPassword"
                                 // value={adminPassword}
                                 className="form-control"
                                 onChange={v=>this.setState({adminPassword: v.target.value})}
                                 placeholder="Password" />
                          : <p>*******</p>
                      }
                    </div>
                  </div>
                  {
                    edit ?
                      <div className="form-group">
                        <label className="col-sm-2 control-label">Repeat Password:</label>
                        <div className="col-sm-10">
                          {
                            edit ?
                              <input type="password"
                                     name="repeatPassword"
                                     // value={repeatPassword}
                                     className="form-control"
                                     onChange={v=>this.setState({repeatPassword: v.target.value})}
                                     placeholder="Repeat Password" />
                              : <p>*******</p>
                          }
                        </div>
                      </div>
                    : null
                  }
                  <div className="form-group">
                    <label className="col-sm-2 control-label" style={{textIndent: -100}}>
                      Regional Admin Email Domain:
                    </label>
                    <div className="col-sm-10">
                      {
                        edit ?
                          <MyCreatable
                            name="regionalAdmin"
                            className="regional-select"
                            value={regionalOption}
                            onChange={this.handleChangeRe}
                            onInputChange={v=>{
                              return v.replace(/[^a-zA-Z0-9@\.\-]*/g, "").toLowerCase();
                            }}
                            multi
                            escapeClearsValue={false}
                            // clearable={false}
                            placeholder='e.g. :"@internationalsos.com"; Please enter , or ; after each domain'
                            options={[]}
                          />
                          : this.renderRegionalText()
                      }
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="col-sm-offset-2 col-sm-10">
                    {
                      edit ?
                        <div style={{maxWidth: 500, textAlign: 'right'}}>
                          <button id="submit" type="submit" className="btn btn-primary">Submit</button>
                          <button className="btn btn-success"
                                  onClick={this.toggleEdit}
                                  style={{marginLeft: 15}}>Back</button>
                        </div>
                      : <div style={{maxWidth: 500, textAlign: 'right'}}>
                          <button type="submit"
                                  onClick={this.toggleEdit}
                                  className="btn btn-primary">
                            Edit
                          </button>
                        </div>
                    }
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/dashboard/model/tenantDetail.js